jQuery(document).ready(function ($) {
    var $testimony = $('.home-testimony .swiper-container');

    if (!$testimony.length) return

    var mySwiper = new Swiper($testimony, {
        autoplay: {
            delay: 7000,
        },
        speed: 550,
        slidesPerView: 3,
        spaceBetween: 30,
        navigation: {
            prevEl: $testimony.parent().find('.carousel-navigation span.prev'),
            nextEl: $testimony.parent().find('.carousel-navigation span.next'),
        },
        pagination: {
            el: '.testimony-navigation',
            clickable: true,
            bulletClass: 'bullet',
            bulletActiveClass: 'bullet-active',
            modifierClass: 'testimony-pagination-'
        },
        breakpoints: {
            991: {
                slidesPerView: 2
            },
            767: {
                slidesPerView: 1
            }
        }
    });

        $testimony.mouseover(function() {
            mySwiper.autoplay.stop();
        }).mouseout(function() {
            mySwiper.autoplay.start();
        });
});